import MessageTabGroup from './MessageTabGroup';

export default MessageTabGroup;
